// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1u8Jj","title":"AfterBackImages_title__27HCr","images":"AfterBackImages_images__t-mb9"};